
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fees",
      function () {
        return require("private-next-pages/fees.js");
      }
    ]);
  